const acceptableStates = ['ONSALE', 'PURCHASED', 'MARKED_AS_SOLD'];

const listMandatoryFields = [
  'slug',
  'publicId',
  'saleStatus',
  'description',
  'dateUpdated',
];

const detailMandatoryFields = [
  ...listMandatoryFields,
  'seller',
  'pictures',
  'counters',
  'price',
];

export default function isProductViewable(product, isDetail) {
  const checkFields = isDetail ? detailMandatoryFields : listMandatoryFields;
  for (const field of checkFields) {
    if (!product[field]) {
      return false;
    }
  }

  if (!acceptableStates.includes(product.saleStatus)) {
    return false;
  }

  return true;
}



// WEBPACK FOOTER //
// ../src/client/utils/isProductViewable.js